import Stack, { type StackProps } from "@mui/material/Stack";
import { styled } from "../../../../lib/styled";
import { sectionGap } from "../../spacing";

interface InternalPageProps extends StackProps {
  /**
   * Content width. `default` constrains to a readable column (forms, queues);
   * `full` removes the cap for wide data tables (e.g. the verification trace).
   */
  width?: "default" | "full";
}

const InternalPageStack = styled(Stack)<{ $maxWidth: number | "none" }>(({ $maxWidth }) => ({
  padding: "16px",
  marginLeft: "auto",
  marginRight: "auto",
  width: "100%",
  maxWidth: $maxWidth,
}));

/**
 * The shell for internal (`#/internal/`) pages: page padding, centered column,
 * and a consistent section gap. The internal analog of `PageContainer` — it has
 * no full-height/centering chrome because internal pages sit inside the
 * `InternalLayout` AppBar.
 */
export function InternalPage({ children, width = "default", ...rest }: InternalPageProps) {
  return (
    <InternalPageStack gap={sectionGap} $maxWidth={width === "full" ? "none" : 700} {...rest}>
      {children}
    </InternalPageStack>
  );
}
